import React, { PureComponent } from "react";
import { Popover, Button } from "antd";
import stylesRem from "./avatarRem.module.less";
import stylesPx from "./avatarPx.module.less";
import { connect } from "dva";
import Icon from "../Icon";
import { downloadImg } from "@/utils/constant";
import Info from "@/routes/home/components/overview/user/Info";
import http from "@/http";
import { LoginUnit } from "@/utils/login-unit";
const HttpUser = http.tokiot.sys.user;
@connect(({ global }) => ({ user: global.user }))
export default class Avatar extends PureComponent {
  state = {
    infoVisible: false,
    popoverVisible: false,
  };

  changeInfoVisible = (id) => {
    if (id && id.length > 0) {
      HttpUser.get({ id }).then((ret) => {
        if (ret) {
          this.setState({
            detail: ret,
            infoVisible: true,
            popoverVisible: false,
          });
        }
      });
    } else {
      this.setState({
        infoVisible: !this.state.infoVisible,
        popoverVisible: false,
      });
    }
  };

  popoverVisibleChange = (visible) => {
    this.setState({ popoverVisible: visible });
  };

  render() {
    const { px, user } = this.props;
    const { userInfo, role, unit } = user;
    const { infoVisible, detail, popoverVisible } = this.state;
    let styles = px ? stylesPx : stylesRem;
    const content = (
      <React.Fragment>
        <div
          className={styles.titleRow}
          onClick={(e) => this.changeInfoVisible(userInfo.id)}
        >
          <Icon antd className={styles.icon} type="user" />
          个人中心
        </div>
        {role && (role.code === `UNIT` || role.code === `UNIT_ADMIN`) ? (
          <div
            className={styles.titleRow}
            onClick={(e) => {
              if (unit && unit.id && unit.id.length > 0) {
                window.open(
                  `${window.location.origin}/enterprise/${unit.id}/home`
                );
              }
            }}
          >
            <Icon.Prop type={`changgui-danwei`} className={styles.icon} />
            跳转企业端
          </div>
        ) : (
          ``
        )}
        <div
          className={styles.titleRow}
          onClick={(e) => {
            LoginUnit.Logout();
          }}
        >
          <Icon antd className={styles.icon} type="export" />
          退出
        </div>
      </React.Fragment>
    );
    const title = (
      <div className={styles.titlePopover}>
        {userInfo ? userInfo.realName : ``}
      </div>
    );

    return (
      <Popover
        overlayClassName={styles.popover}
        visible={popoverVisible && !infoVisible}
        onVisibleChange={this.popoverVisibleChange}
        content={content}
        title={title}
      >
        {infoVisible ? (
          <Info
            visible={infoVisible}
            detail={detail}
            onClose={this.changeInfoVisible}
            onChange={this.refreshUsertList}
          />
        ) : (
          ``
        )}
        {userInfo ? (
          <div className={styles.avatar}>
            <img
              className={styles.image}
              src={downloadImg + userInfo.avatar}
              alt=""
            />
          </div>
        ) : (
          ``
        )}
      </Popover>
    );
  }
}
